import React from "react";
import TextField from "@mui/material/TextField";

interface TextInputProps {
  name: string;
  value: string;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  classes?: { textField?: string; input?: string };
}

function TextInput({
  name,
  value,
  label,
  onChange,
  error,
  classes,
}: TextInputProps) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      type="text"
      name={name}
      value={value}
      label={label}
      onChange={onChange}
      helperText={error}
      error={!!error}
      sx={{ bgcolor: "background.paper" }}
    />
  );
}

export default TextInput;
